// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"014c41c6","521":"929ed291"}[chunkId] + ".chunk.js";
};